import React from "react";
import DelayReasonsGrid from "../sof/DelayReasonsGrid";
import InputValuesForm from "../sof/InputValuesForm";
import moment from "moment";
import Moment from "react-moment";
import { ActionButtonIcon } from "../sof/ActionButtonIcon";
import { ActivityInputValue } from "../../models/ProcessFlowConfig";
import { ActivityLog } from "../../models/ProcessFlowConfig";
import { ActivityService } from "../../services/ActivityService";
import { DefaultButton } from "@fluentui/react";
import { DelayReasonModel } from "../../models/ProcessConfig";
import { ExecuteAction2 } from "../../models/ProcessFlowConfig";
import { FC } from "react";
import { FontIcon } from "@fluentui/react";
import { Fragment } from "react";
import { InputValue } from "../../models";
import { ISofProps } from "./TruckSofPage";
import { Link, useLocation } from "react-router-dom";
import { MessageBar } from "@fluentui/react";
import { MessageBarType } from "@fluentui/react";
import { mergeStyleSets } from "@fluentui/react";
import { ProcessFlowAction } from "../../models/ProcessFlowConfig";
import { ProcessFlowStep } from "../../models/ProcessFlowConfig";
import { PrimaryButton } from "@fluentui/react";
import { Spinner } from "@fluentui/react";
import { SpinnerSize } from "@fluentui/react";
import { SofProcessor } from "../../services/SofProcessor";
import { toOrdinalString } from "../../services/Helper";
import { TruckNomination } from "../../models";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useState } from "react";
import SofIcon from "../common/Icons";
import { AuthProvider } from "../../AuthProvider";
import { Get, Delete } from "../../api/apiUtils";
import Axios from "axios";
import { loadPdfDoc } from "../../services/PdfDocumentService";
import { useHistory } from "react-router-dom";
import { GeneralService } from "../../services/GeneralService";

interface Props extends ISofProps {
  step: ProcessFlowStep | undefined;
  surveyor?: string;
  onCancel(hasError: boolean): void;
  onStateChange(
    newState: string,
    truckNomination: TruckNomination,
    activityLogs: ActivityLog[]
  ): void;
}
const classes = mergeStyleSets({
  container: {
    padding: 35,
    width: 520
  },
  header: {
    display: "flex",
    flex: "1 1 auto"
  },
  collapsibleHeader: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    padding: "8px 4px",
    marginTop: 12,
    borderTop: "1px solid #E2E6E8",
    fontWeight: "bolder",
    textTransform: "capitalize"
  },
  body: {
    maxHeight: "400px",
    overflow: "auto",
    overflowX: "hidden",
    padding: 4
  },
  footer: {
    marginTop: 35,
    display: "flex",
    direction: "rtl",
    justifyContent: "space-between"
  },
  title: {
    fontWeight: 500,
    fontSize: 20,
    lineHeight: 23,
    alignItems: "center",
    letterSpacing: "0.0015em",
      color: "#212529"
  },
  buttons: {
    borderRadius: 2,
    height: 52,
    width: 210
  },
  inputField: {
    fontSize: "22px !important",
    textAlign: "left"
  },
  calendar: {
    fontSize: 15
  },
  inputValue: {
    display: "flex",
    justifyContent: "space-between",
    border: "1px solid #E2E6E8",
    backgroundColor: "#FAFAFA",
    padding: 6,
    marginBottom: 4
  },
  linkButton: {
    border: "solid 1px #D8DFE6",
    background: "#F2F4F6",
    color: "#4C4C4C",
    display: "block",
    borderRadius: 5,
    width: "100%",
    padding: 8,
    selectors: {
      [":hover"]: {
        textDecoration: "none",
        backgroundColor: "#D8DFE6",
        color: "#4C4C4C"
      }
    }
  }
});

type MODALITY = "MARINE" | "TRUCK" | "RAIL";
const ActionModal: FC<Props> = (props: Props) => {
  const { activityLogs, truckNomination } = props;
  const { step, surveyor, correlationId, selectedState } = props;
  const [stepActivityLogs, setStepActivityLogs] = useState<ActivityLog[]>();
  const [description, setDescription] = useState<string>();
  const [createdOn, setCreatedOn] = useState<string>();
  const [startedOn, setStartedOn] = useState<string>();
  const [finishedOn, setFinishedOn] = useState<string>();
  const [order, setOrder] = useState(0);
  const [status, setStatus] = useState(0);
  const [inputValues, setInputValues] = useState<ActivityInputValue[]>();
  const [isDone, setIsDone] = useState(false);
  const [action, setAction] = useState<ProcessFlowAction>();
  const [actionDateTime, setActionDateTime] = useState<Date>();
  const [delayReason, setDelayReason] = useState<string>();
  const [delayReasons, setDelayReasons] = useState<DelayReasonModel>();
  const [isDelayReasonRequired, setIsDelayReasonRequired] = useState(false);
  const [isDelayReasonInvalid, setIsDelayReasonInvalid] = useState(false);
  const [inputValuesOption, setInputValuesOption] = useState<InputValue[]>();
  const [formInputValues, setFormInputValues] = useState<InputValue[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string>();
  const [stepActionCount, setStepActionCount] = useState<number>(0);
  const [showLargeForm, setShowLargeForm] = useState(false);
  const location = useLocation();
  const [modality, setModality] = useState<MODALITY>("MARINE");
  const [generalService, setGeneralService] = useState<GeneralService>();
  const history = useHistory();

  const modalities = {
    MARINE: 0,
    TRUCK: 1,
    RAIL: 2
  };

  let param = useParams() as any;
  const nominationNo = param.lineHandlingNo;

  useEffect(() => {
    if (history.location.pathname.indexOf("truck") > 0) {
      setModality("TRUCK");
    } else if (history.location.pathname.indexOf("rail") > 0) {
      setModality("RAIL");
    } else {
      setModality("MARINE");
    }
  }, []);

  useEffect(() => {
    const genService = new GeneralService(
      props.lineHandling.result,
      truckNomination.result,
      props.activityLogs.result,
      props.workPacketValues.result
    );
    setGeneralService(genService);
  }, [props.truckNomination]);

  const executeAction = async (
    actionId: number,
    inputValues: ActivityInputValue[] | undefined = undefined
  ) => {
    const activityService = new ActivityService();
    const nominationNo = truckNomination.result
      ? truckNomination.result.nominationNo
      : "0";
    const hasOfflineData = null;
    // props.offlineData.filter((f) => f.lineHandlingNo === lineHandlingNo)
    //   .length > 0;
    if (step) {
      setIsLoading(true);
      const exeActivity = {
        stepId: step.id,
        nominationNo: nominationNo,
        actionId,
        executionTime: getActionTimeString(),
        inputValues,
        order,
        surveyor,
        correlationId
      } as ExecuteAction2;
      try {
        // const result = hasOfflineData
        //   ? await activityService.offlineExecuteAsync(
        //       exeActivity,
        //       props.account.accountIdentifier,
        //       () => props.insertOfflineData(lineHandlingNo, exeActivity)
        //     )
        //   : await activityService.executeNominationActionAsync(
        //       exeActivity,
        //       props.account.accountIdentifier,
        //       () => props.insertOfflineData(lineHandlingNo, exeActivity)
        //     );

        const result = await activityService.executeNominationActionAsync(
          exeActivity,
          props.account.accountIdentifier
        );

        let _nomination =
          truckNomination.result !== undefined
            ? truckNomination.result
            : ({} as TruckNomination);

        if (_nomination) {
          _nomination = {
            ...props.truckNomination.result,
            ...result.result
          };

          props.setTruckNomination(_nomination);
        }

        props.insertActivityLogs(result.activities, (activityLogs) => {
          if (result.newState && result.newState !== selectedState) {
            if (!(description && description.startsWith("Skip to "))) {
              props.onStateChange(result.newState, _nomination, activityLogs);
            } else {
              props.setSelectedState(result.newState);
            }
          }
        });

        switch (modalities[modality]) {
          case 1:
          case 2:
            console.log(result);
            if (result.newStatus === 2) {
              console.log("Upload documents");
              props.getAllWorkPackets();
              props.getWPValues(nominationNo);
              await uploadDocuments(nominationNo);
            }
            break;
        }
        onClose();

        // let _lineHandling =
        //   lineHandling.result !== undefined
        //     ? lineHandling.result
        //     : ({} as LineHandling);
        // if (result.result) {
        //   let nominations: Nomination[] | undefined = [];
        //   nominations = lineHandling.result && lineHandling.result.nominations;
        //   if (result.result.nominations && nominations) {
        //     for (let n of result.result.nominations) {
        //       let nom: Nomination | undefined = nominations.find(
        //         (f) =>
        //           f.nominationNo.toLowerCase() === n.nominationNo.toLowerCase()
        //       );
        //       if (nom)
        //         nominations = [
        //           ...nominations.filter(
        //             (f) => f.nominationNo !== n.nominationNo
        //           ),
        //           { ...nom, ...n },
        //         ];
        //     }
        //   }
        //   _lineHandling = {
        //     ...props.lineHandling.result,
        //     ...result.result,
        //     nominations,
        //   };
        //   props.setLineHandling(_lineHandling);
        //   if (nomination) {
        //     props.setActiveNomination(nomination.nominationNo, false);
        //   }
        // }
        // props.insertActivityLogs(result.activities, (activityLogs) => {
        //   if (result.newState && result.newState !== selectedState) {
        //     if (!(description && description.startsWith("Skip to "))) {
        //       props.onStateChange(result.newState, _lineHandling, activityLogs);
        //     } else {
        //       props.setSelectedState(result.newState);
        //     }
        //   }
        // });
        // onClose();
      } catch (ex) {
        const error = ex as Error;
        if (error) {
          setErrorMessage(error.message);
          setIsLoading(false);
        }
      }
    }
  };

  const loadFiles = async (lineHandlingNo: string) => {
    let modalityPath;

    switch (modalities[modality]) {
      case 1:
        modalityPath = "truck";
        break;
      case 2:
        modalityPath = "rail";
        break;
    }

    const response = await Get(
      `/api/Attachment/${modalityPath}/reports/${lineHandlingNo}`
    );
    const resultRes = await response.json();
    const attachments = await Promise.all(
      (resultRes || []).map(async (file: any) => {
        //const base64Data = await getBase64FromUrl(file.url);
        return {
          attachmentId: file.attachmentId,
          //previewBase64: base64Data,
          previewBlob: file.url,
          name: file.fileName,
          size: file.fileSize,
          canDelete: file.canDelete
        };
      })
    );
    return attachments;
  };
  const uploadDocuments = async (lineHandlingNo: string) => {
    const token = await AuthProvider.getIdToken();
    const source = Axios.CancelToken.source();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token.idToken.rawIdToken}`
      },
      cancelToken: source.token
    };

    //get all attachments
    const files = await loadFiles(lineHandlingNo);
    console.log(files);
    //delete all attachments
    files?.forEach(async (file: any) => {
      await Delete(`/api/Attachment/${file.attachmentId}`);
    });

    //reupload
    const documents = props.workPacketDocuments.result?.filter(
      (f) => f.workPacketType > 1
    );

    console.log(documents);
    documents?.forEach(async (doc) => {
      const workPacket = props.workPackets.result?.filter(
        (f) => f.id === doc.workPacketId
      );

      const pdfFile =
        workPacket === undefined ? "" : workPacket[0].layouts[0].pdfFile;

      const pdfDoc = await loadPdfDoc(
        pdfFile,
        lineHandlingNo,
        doc.nominationNo,
        doc.workPacketType === 3 ? doc.id : undefined,
        props.lineHandling,
        props.workPacketValues
      );
      if (pdfDoc) {
        const base64String = await pdfDoc.saveAsBase64({ dataUri: true });

        const last2 = base64String.slice(-2);
        const fileSize =
          base64String.length * (3 / 4) - (last2 === "==" ? 2 : 1);

        const payload = {
          fileName: doc.name,
          content: base64String,
          fileSize: fileSize
        };

        let modalityPath;

        switch (modalities[modality]) {
          case 1:
            modalityPath = "truck";
            break;
          case 2:
            modalityPath = "rail";
            break;
        }

        await Axios.post(
          `/api/Attachment/${modalityPath}/reports/${lineHandlingNo}`,
          JSON.stringify(payload),
          config
        );
      }
    });
  };

  const getActionTimeString = () => {
    const actionDateTime = new Date();
    setActionDateTime(actionDateTime);
    return actionDateTime.toISOString();
  };

  const onClose = () => {
    props.onCancel(errorMessage ? true : false);
    props.setVerifyInformation(false);
  };

  const actionClick = (processFlowAction: ProcessFlowAction) => {
    if (
      checkDelayReasons(processFlowAction) ||
      checkInputValues(processFlowAction)
    ) {
      setAction(processFlowAction);
    } else {
      executeAction(processFlowAction.id);
    }
  };

  const checkDelayReasons = (processFlowAction: ProcessFlowAction): boolean => {
    if (processFlowAction.delayReasons) {
      setDelayReasons(processFlowAction.delayReasons);

      const compareTo = startedOn ? startedOn : createdOn;
      const recommendedDuration = moment
        .utc(compareTo)
        .add(processFlowAction.delayReasons.interval, "m");

      const result = recommendedDuration.isSameOrBefore(
        moment(getActionTimeString())
      );
      setIsDelayReasonRequired(result);
      return result;
    }
    return false;
  };

  const checkInputValues = (processFlowAction: ProcessFlowAction): boolean => {
    if (processFlowAction.inputValues.length > 0) {
      setInputValuesOption(processFlowAction.inputValues);

      if (processFlowAction.inputValues.length > 0) {
        const containsColSpan =
          processFlowAction.inputValues.filter((f) => f.colSpan !== undefined)
            .length > 0;
        setShowLargeForm(containsColSpan);
        setFormInputValues(processFlowAction.inputValues);
        return true;
      }
    }
    return false;
  };

  const replaceMergeFields = (text: string): string => {
    if (
      text.indexOf("{surveyor}") >= 0 &&
      truckNomination &&
      truckNomination.result &&
      truckNomination.result.surveyor
    ) {
      var _surveyor = surveyor
        ? surveyor
        : truckNomination
        ? truckNomination.result.surveyor
        : "surveyor";
      if (_surveyor) text = text.replace("{surveyor}", _surveyor);
    } else if (text.indexOf("{vesseltype}") >= 0) {
      if (truckNomination.result)
        text = text.replace("{vesseltype}", truckNomination.result.vesselType);
    } else if (text.indexOf("{n}") >= 0) {
      text = text.replace("{n}", toOrdinalString(order));
    }

    return text;
  };

  const onSubmit = (data: ActivityInputValue[]) => {
    if (action) {
      // get input values from Form
      // let keys = Object.keys(e.formData as object);
      // let vals = Object.values(e.formData as object);
      // let hasError = false;

      // const inputVals = keys.map((k, i) => {
      //   const inpVal =
      //     inputValuesOption && inputValuesOption.find((p) => p.caption === k);

      //   if (k === "N2 Closing Reading") {
      //     const openingReading =
      //       inputValues &&
      //       inputValues.find((f) => f.caption === "N2 Opening Reading");
      //     if (openingReading) {
      //       if (parseFloat(openingReading.value) > parseFloat(vals[i])) {
      //         setErrorMessage(
      //           "N2 Closing Reading must be greather than N2 Opening Reading."
      //         );
      //         hasError = true;
      //       }
      //     }
      //   }

      //   if (inpVal) {
      //     const { unit, type, workPacketField } = inpVal;
      //     return {
      //       caption: k,
      //       type: type,
      //       value: vals[i] + (unit && unit !== "" ? ` ${unit}` : ""),
      //       workPacketField,
      //       workPacketValue: vals[i]
      //     } as ActivityInputValue;
      //   }

      //   return {
      //     caption: k,
      //     type: "text",
      //     value: vals[i]
      //   } as ActivityInputValue;
      // });

      // if (hasError) return;

      // input value from delay reason
      let delayReasonInputVal: ActivityInputValue[] = [];
      if (isDelayReasonRequired) {
        if (!delayReason || delayReason.trim() === "") {
          setIsDelayReasonInvalid(true);
          return;
        }

        delayReasonInputVal = [
          {
            caption: "Delay reason",
            type: "text",
            value: delayReason
          } as ActivityInputValue
        ];
      }

      executeAction(action.id, [...data, ...delayReasonInputVal]);
    }
  };

  const onConfirm = () => {
    if (action && isDelayReasonRequired) {
      if (!delayReason || delayReason.trim() === "") {
        setIsDelayReasonInvalid(true);
        return;
      } else {
        setIsDelayReasonInvalid(false);

        executeAction(action.id, [
          {
            caption: "Delay reason",
            type: "text",
            value: delayReason
          } as ActivityInputValue
        ]);
      }
    }
  };

  useEffect(() => {
    if (activityLogs.result && step) {
      const acts = activityLogs.result.filter(
        (f) =>
          f.processStepId === step.id &&
          f.surveyor === surveyor &&
          (truckNomination.result === undefined ||
            f.nominationNo === nominationNo.toUpperCase())
      );
      setStepActivityLogs(acts);
      const maxRepeationOrder = Math.max.apply(
        null,
        acts.map((s) => s.repetitionOrder)
      );
      const activeActivities = acts.filter(
        (f) => f.repetitionOrder === maxRepeationOrder
      );

      let inputVal: ActivityInputValue[] = [];
      for (var ctr = 0; ctr < activeActivities.length; ctr++) {
        const activeAct = activeActivities[ctr];
        if (activeAct.status === 0) {
          setCreatedOn(activeAct.logTime);
        } else if (activeAct.status === 1) {
          setStartedOn(activeAct.logTime);
        } else if (activeAct.status === 2) {
          setFinishedOn(activeAct.logTime);
        }
        if (activeAct.inputValues && activeAct.inputValues.length > 0) {
          inputVal = [...inputVal, ...activeAct.inputValues];
        }

        if (ctr === activeActivities.length - 1) {
          setStatus(activeAct.status);
          setDescription(activeAct.description);
          setIsDone(activeAct.status === 2);
        }
      }

      setOrder(maxRepeationOrder);
      setInputValues(inputVal);
      setActionDateTime(new Date());
      setActionDateTime(new Date());
    }
  }, [step]);

  useEffect(() => {
    if (step) {
      var actionCount = 0;

      var filteredActions = step.actions.filter((f) =>
        SofProcessor.checkConditionsByNomination(
          f.displayConditions,
          truckNomination.result,
          []
        )
      );

      actionCount = filteredActions.length;

      if (truckNomination.result) {
        actionCount = filteredActions.filter(
          (f) => f.displayAt === status
        ).length;
      }

      setStepActionCount(actionCount);
    }
  }, [step, status]);

  useEffect(() => {
    if (showLargeForm) {
      props.setVerifyInformation(true);
    } else {
      props.setVerifyInformation(false);
    }
  }, [step, showLargeForm]);

  return (
    <div className="modal-bg">
      <div
        className={`modal-right ${showLargeForm ? "verify-information" : ""}`}
        style={{ width: showLargeForm ? 790 : 520 }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between"
            // alignItems: "center",
          }}
        >
          <span className={classes.title}>Activity Details</span>
          <button className="btn-close" onClick={onClose}>
            <FontIcon iconName="cancel" />
          </button>
        </div>

        {errorMessage && (
          <div className="field">
            <MessageBar
              messageBarType={MessageBarType.error}
              onDismiss={onClose}
              dismissButtonAriaLabel="Close"
            >
              {errorMessage}
            </MessageBar>
          </div>
        )}
        <div
          style={{
            fontWeight: "bolder",
            textAlign: "left",
            margin: "10px 0 10px 0"
          }}
        >
          <span id="lbl-activity-title">{description}</span>
        </div>

        {isDone && startedOn && (
          <div style={{ fontSize: "14px" }}>
            <FontIcon iconName="clock" />
            &nbsp;
            <Moment format="ll HH:mm" local>
              {startedOn}
            </Moment>
          </div>
        )}
        {isDone && finishedOn && (
          <div style={{ fontSize: "14px" }}>
            <FontIcon iconName="clock" />
            &nbsp;
            <Moment format="ll HH:mm" local>
              {finishedOn}
            </Moment>
          </div>
        )}
        {!isDone && (
          <>
            <div style={{ textAlign: "left", fontSize: "14px" }}>
              <FontIcon iconName="clock" />
              &nbsp;
              <Moment format="ll HH:mm" local>
                {actionDateTime}
              </Moment>
              {step?.description && (
                <Fragment>
                  <br />
                  <p
                    style={{
                      fontSize: "18px",
                      marginTop: "8px",
                      marginBottom: "12.5px",
                      color: "#4C4C4C"
                    }}
                  >
                    {generalService?.replaceMergeField(step?.description) ?? ""}
                  </p>
                </Fragment>
              )}
            </div>

            {step?.workPacketId && (
              <div className="action-buttons" style={{ paddingTop: 16 }}>
                <Link
                  className={classes.linkButton}
                  to={`/${modality.toLowerCase()}/${nominationNo}/work-packet/${
                    step.workPacketId
                  }?referer=${encodeURIComponent(location.pathname)}`}
                >
                  <SofIcon iconname="Link" />
                  &nbsp;Go to Form
                </Link>
              </div>
            )}

            <div>
              {/* {action && (
                <div
                  style={{
                    fontWeight: "bolder",
                    textAlign: "left",
                    margin: "20px 0 10px 0",
                  }}
                >
                  {replaceMergeFields(action.name)}
                </div>
              )} */}
              {!action && (
                <div
                  className="ms-Grid"
                  dir="ltr"
                  style={{ padding: "0", marginTop: "20px" }}
                >
                  <div className="ms-Grid-row">
                    {step &&
                      step.actions
                        // .filter((f) =>
                        //   SofProcessor.checkConditions(
                        //     f.displayConditions,
                        //     truckNomination.result,
                        //     nomination,
                        //     []
                        //   )
                        // )
                        .map(
                          (action) =>
                            truckNomination.result &&
                            action.displayAt === status && (
                              <div
                                className={`ms-Grid-col ${
                                  stepActionCount === 1 ? "ms-md12" : "ms-md6"
                                }`}
                                style={{ paddingLeft: "0px" }}
                              >
                                <div className="action-buttons">
                                  <button
                                    key={`action-${action.id}`}
                                    id={`btn-action-${action.id}`}
                                    style={{
                                      textAlign:
                                        stepActionCount === 1
                                          ? "center"
                                          : "left"
                                    }}
                                    disabled={isLoading}
                                    onClick={() => actionClick(action)}
                                  >
                                    {isLoading ? (
                                      <Spinner
                                        size={SpinnerSize.small}
                                        style={{ display: "inline-block" }}
                                      />
                                    ) : (
                                      <ActionButtonIcon icon={action.icon} />
                                    )}
                                    &nbsp;{action.caption}
                                  </button>
                                </div>
                              </div>
                            )
                        )}
                  </div>
                </div>
              )}
            </div>

            {action &&
              inputValues &&
              inputValues
                .filter(
                  (f) =>
                    f.caption !== "Surveyor" && f.caption !== "Delay reason"
                )
                .map((inputVal, index) => (
                  <div
                    key={`input-val-${index}`}
                    style={{ textAlign: "left", marginBottom: "10px" }}
                  >
                    <div style={{ fontSize: "14px" }}>{inputVal.caption}</div>

                    <input
                      className="form-control"
                      type="text"
                      value={inputVal.value}
                      disabled
                    />
                  </div>
                ))}

            {delayReasons && isDelayReasonRequired && (
              <DelayReasonsGrid
                disabled={isLoading}
                model={delayReasons}
                onSelectionChange={(value: string) => {
                  setDelayReason(value);
                  setIsDelayReasonInvalid(
                    value === undefined || value === null || value.trim() === ""
                  );
                }}
              />
            )}

            {formInputValues.length > 0 && (
              <InputValuesForm
                startInputValues={inputValues}
                inputValues={formInputValues}
                disabled={isLoading}
                onClose={onClose}
                onSubmit={onSubmit}
                generalService={generalService}
              />
            )}
            {formInputValues.length <= 0 && action && (
              <div className="ms-Grid" dir="ltr" style={{ marginTop: "20px" }}>
                <div className="ms-Grid-row">
                  <div
                    className="ms-Grid-col ms-md6"
                    style={{ paddingLeft: "0px", paddingRight: "5px" }}
                  >
                    <PrimaryButton
                      className="action-button-submit"
                      id="btn-confirm-action"
                      type="submit"
                      onClick={onConfirm}
                      disabled={isLoading}
                      style={{ height: "52px" }}
                    >
                      Confirm
                    </PrimaryButton>
                  </div>
                  <div
                    className="ms-Grid-col ms-md6"
                    style={{ paddingLeft: "5px", paddingRight: "0px" }}
                  >
                    <DefaultButton
                      className="action-button-submit"
                      id="btn-cancel-action"
                      type="button"
                      onClick={onClose}
                      disabled={isLoading}
                      style={{ height: "52px" }}
                    >
                      Cancel
                    </DefaultButton>
                  </div>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};
export default ActionModal;
